import { useSelector } from 'react-redux';
import useGeneralProjectRealtime from './useGeneralProjectRealtime';
export { readJobSnapshot } from './jobSnapshot';

export function canRefreshJob(state, identity) {
  return state.readOnly?.isReadOnly === true && String(state.jobId?.jobId) === String(identity.jobId)
    && state.apiUrls?.urls?.fullJob === identity.url && state.user?.userDetails === identity.user
    && !state.fullJobFetch?.loading && !state.fullJobFetch?.syncing;
}

// Read-only job mode can still contain independent editors (Ship Early/Change
// Orders). Use the same draft and in-flight-save safeguards as editable jobs.
export default function useReadonlyJobRealtime(jobId, ready) {
  const readOnly = useSelector(state => state.readOnly?.isReadOnly === true);
  useGeneralProjectRealtime({ jobId, enabled: Boolean(readOnly && jobId && ready), snapshotEditable: false });
}
